import { defineField, defineType } from 'sanity'
import { PageBlockTypes } from '../pageBlocks'
import getPageInfo, { seoGroup } from '../objects/pageInfo'

export default defineType({
  title: 'Customer support article',
  name: 'customerSupportArticle',
  type: 'document',
  orderings: [
    {
      title: 'Title A-Z',
      name: 'titleAsc',
      by: [{field: 'pageInfo.title', direction: 'asc'}],
    },
  ],
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [
    defineField({
      title: 'Disable header H1',
      name: 'disableHeaderH1',
      type: 'boolean',
      initialValue: false,
      group: 'content',
    }),
    defineField({
      title: 'Page blocks',
      name: 'pageBlocks',
      type: 'array',
      of: [...PageBlockTypes],
      group: 'content',
    }),
    defineField({
      ...getPageInfo({ path: 'customerSupportArticle' }),
    }),
  ],
  preview: {
    select: {
      name: 'pageInfo.title',
    },
    prepare({ name: title = 'New page' }) {
      return { title }
    },
  },
})